import React from "react";

// TODO: Remove this component
const FlexRow = (props) => {
  return (
    <div style={{ ...props.style, ...{ display: "flex" } }}>
      {props.children}
    </div>
  );
};

export default FlexRow;